import React, { useCallback, useState } from "react";
import { Box, Grid } from "atoms";

import { OtpForm } from "molecules";
import { useAuth } from "contexts/Auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { QUERY_PARAMS_ITEMS } from "utils/constants";

const Otp = () => {
  const {
    state: { userData },
    actions: { verifyOtp, resendOtp, resendForgotPassword },
  } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const workflowType = searchParams.get(QUERY_PARAMS_ITEMS.workflow);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = useCallback(
    async ({ otp }) => {
      setLoading(true);
      verifyOtp(
        userData?.email,
        otp,
        workflowType === QUERY_PARAMS_ITEMS.isLogin
      )
        .then((success) => {
          if (workflowType === QUERY_PARAMS_ITEMS.isResetPassword) {
            success &&
              navigate(
                { pathname: "/reset-password" },
                { state: { userEmail: userData?.email } }
              );
          }
        })
        .catch((e) => {
          setError(e?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [verifyOtp, navigate, userData?.email, workflowType]
  );

  return (
    <Box h="100vh">
      <Grid aI="center" h="100vh" px="12rem">
        <OtpForm
          onSubmit={onSubmit}
          onResend={
            {
              [QUERY_PARAMS_ITEMS.isLogin]: resendOtp,
              [QUERY_PARAMS_ITEMS.isResetPassword]: resendForgotPassword,
            }[workflowType]
          }
          loading={loading}
          error={error}
          resetError={() => setError("")}
          email={userData?.email}
        />
      </Grid>
    </Box>
  );
};

export default Otp;
